var _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgTemp({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    xmlns: "http://www.w3.org/2000/svg",
    "aria-hidden": "true",
    display: "block",
    className: "vkuiIcon vkuiIcon--24 vkuiIcon--w-24 vkuiIcon--h-24 vkuiIcon--lightbulb_star_outline_24",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    style: {
      width: 24,
      height: 24
    },
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("symbol", {
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    viewBox: "0 0 24 24",
    id: "lightbulb_star_outline_24"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M18.924 4.305a.446.446 0 0 0-.848 0l-.457 1.373a1.49 1.49 0 0 1-.942.941l-1.372.457a.447.447 0 0 0 0 .848l1.372.457c.445.148.794.497.942.941l.457 1.373a.447.447 0 0 0 .848 0l.457-1.373c.148-.444.497-.793.942-.94l1.372-.458a.447.447 0 0 0 0-.848l-1.372-.457a1.49 1.49 0 0 1-.942-.941z"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    d: "M5.8 10.345C5.8 6.688 8.594 3.8 12 3.8c1.075 0 2.08.282 2.956.78a.9.9 0 1 0 .89-1.565A7.75 7.75 0 0 0 12 2c-4.483 0-8 3.78-8 8.345 0 2.366.78 3.9 1.72 5.1.358.457.747.875 1.094 1.246l.253.273c.384.417.697.784.934 1.168l.412 1.728c.057.241.11.466.17.654.065.206.154.424.307.632a2.1 2.1 0 0 0 .871.687c.238.101.47.137.686.153.196.014.428.014.676.014h1.754c.248 0 .48 0 .676-.014.215-.016.448-.052.686-.153a2.1 2.1 0 0 0 .87-.687c.154-.209.243-.426.308-.632.06-.188.113-.413.17-.654L16 18.132c.299-.486.706-.924 1.212-1.467l.154-.166c.59-.636 1.263-1.388 1.776-2.379a.9.9 0 0 0-1.598-.828c-.392.758-.918 1.358-1.497 1.983l-.168.18c-.432.462-.905.969-1.29 1.545H12.9v-2.054l1.745-1.33a.9.9 0 0 0-1.09-1.432L12 13.37l-1.555-1.185a.9.9 0 0 0-1.09 1.432l1.745 1.33V17H9.412c-.31-.466-.673-.877-1.02-1.255l-.288-.31a17 17 0 0 1-.967-1.1C6.4 13.395 5.8 12.24 5.8 10.345m4.357 9.072c.066.276.105.436.142.554a1 1 0 0 0 .042.109.3.3 0 0 0 .121.096 1 1 0 0 0 .115.015c.124.009.289.009.572.009h1.702c.283 0 .448 0 .572-.01a1 1 0 0 0 .115-.015.3.3 0 0 0 .121-.095 1 1 0 0 0 .042-.11c.037-.117.076-.277.142-.553l.147-.617h-3.98z",
    clipRule: "evenodd"
  })))), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#lightbulb_star_outline_24",
    style: {
      fill: "currentcolor"
    }
  }));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTemp);
export default __webpack_public_path__ + "static/media/temp.ae942daacd0a6e3a90032cb8a25a98eb.svg";
export { ForwardRef as ReactComponent };